var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "content",
      },
      [
        _c(
          "div",
          { staticClass: "form-search" },
          [
            _c("div", { staticClass: "label" }, [_vm._v("搜索")]),
            _c("el-input", {
              staticClass: "search-input",
              attrs: {
                placeholder: "请输入搜索内容",
                "suffix-icon": "el-icon-search",
                size: "small",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.fetchData.apply(null, arguments)
                },
              },
              model: {
                value: _vm.keyword,
                callback: function ($$v) {
                  _vm.keyword = $$v
                },
                expression: "keyword",
              },
            }),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.fetchData },
              },
              [_vm._v("查询")]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.fetchData("reset")
                  },
                },
              },
              [_vm._v("重置")]
            ),
          ],
          1
        ),
        _vm.total > 0
          ? _vm._l(_vm.list, function (item, index) {
              return _c("div", { key: index }, [
                item.count > 0
                  ? _c(
                      "dl",
                      { staticClass: "list-dl" },
                      [
                        _c("dt", { staticClass: "list-dt" }, [
                          _vm._v(
                            _vm._s(item.groupName) +
                              "(" +
                              _vm._s(item.count) +
                              ")"
                          ),
                        ]),
                        _vm._l(item.templates, function (item2, index2) {
                          return _c(
                            "dd",
                            {
                              key: index2,
                              staticClass: "list-dd",
                              on: {
                                click: () => {
                                  _vm.$router.push({
                                    name: "sendApproval",
                                    query: { id: item2.id },
                                  })
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "name" }, [
                                _c("i", { staticClass: "icon" }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ellipsis2",
                                    attrs: { title: item2.templateName },
                                  },
                                  [_vm._v(_vm._s(item2.templateName))]
                                ),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ])
            })
          : _vm.total === 0
          ? _c("div", { staticClass: "no-data-container" }, [_vm._m(0)])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "no-data" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/img_wushuju.png"), alt: "" },
      }),
      _c("div", { staticClass: "text" }, [_vm._v("暂无数据")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }